export * from "./types.js";
export * from "./copy.js";
export {
  schemeEligibility,
  fhbPeriodForDate,
  assertNoCreditHandoff,
  CreditHandoffError,
  ALLOWED_RESULT_PLACEMENTS,
  FORBIDDEN_CREDIT_PLACEMENTS,
} from "./calculate.js";
export type { AllowedPlacement, ForbiddenPlacement } from "./calculate.js";
export { tables_2025_10_01 } from "./tables-2025-10-01.js";
export { tables_2026_07_01 } from "./tables-2026-07-01.js";

import type { FhbRuleSet } from "./types.js";
import { fhbPeriodForDate } from "./calculate.js";
import { tables_2025_10_01 } from "./tables-2025-10-01.js";
import { tables_2026_07_01 } from "./tables-2026-07-01.js";

/**
 * Registry of first-home-scheme rule periods, keyed by `periodKey` (ISO start).
 * The QLD FHOG 30-Jun-2026 sunset is two registered periods, never a mutation —
 * a contract on/before 30 Jun 2026 resolves $30k, one from 1 Jul 2026 resolves
 * $15k. Historical periods stay registered so backdated assessments resolve
 * against the rules in force then (ruleset immutability).
 */
export const FIRST_HOME_SCHEME_RULESETS: Record<string, FhbRuleSet> = {
  "2025-10-01": tables_2025_10_01,
  "2026-07-01": tables_2026_07_01,
};

/** Rule periods newest-first, for date resolution. */
const PERIODS_DESC: readonly FhbRuleSet[] = Object.values(FIRST_HOME_SCHEME_RULESETS).sort(
  (a, b) => (a.effectiveFrom < b.effectiveFrom ? 1 : -1),
);

/** Resolve the first-home-scheme ruleset in force on an ISO date (YYYY-MM-DD). */
export function firstHomeSchemeRulesForDate(isoDate: string): FhbRuleSet {
  return fhbPeriodForDate(isoDate, PERIODS_DESC);
}

/** Most recent rule period — the default for live "today" assessments. */
export const FIRST_HOME_SCHEME_CURRENT = tables_2026_07_01;
